import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { actionCreateApiGateWayFactory } from '../../actions/actionCreator';

import {
  ACTION_KEY as API_GATEWAY_KEYS,
  ACTION_ATTR as API_GATEWAY_ATTRS,
} from '../../constants/apiGateWayConstant';

import PrefixScan from '../../components/Reports/PrefixScan';

function mapStateToProps(state) {
  return {
    nextReport: state.nextReport.reportData,
    LastEvaluatedKey: state.nextReport.LastEvaluatedKey,
  };
}

const mapDispatchToProps = dispatch => ({
  actions: {
    getNextReport: bindActionCreators(
      actionCreateApiGateWayFactory(
        API_GATEWAY_KEYS.GET_NEXT_REPORT,
        API_GATEWAY_ATTRS.PAYLOAD,
      ),
      dispatch,
    ),
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrefixScan);



// WEBPACK FOOTER //
// ./src/Containers/Reports/PrefixScan.js